import React from "react";

const ModeType = ({ label }) => {
  return (
    <span className="ml-4">
      <span
        data-source-pos="334:4-337:10"
        data-source-name="div"
        class="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs bg-emerald-50 text-emerald-700"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-circle-check h-3 w-3"
          aria-hidden="true"
          data-source-pos="335:12-335:47"
          data-source-name="CheckCircle2"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m9 12 2 2 4-4"></path>
        </svg>
        <span data-source-pos="336:6-336:26" data-source-name="span">
          {label}
        </span>
      </span>
    </span>
  );
};

export default ModeType;
